
            // Conditional favicon for local dev
            if (import.meta.env.VITE_LOCAL_ICON) {
                document.querySelector('link[rel="icon"]').href =
                    '/favicon-local.png'
                document.querySelector('link[rel="apple-touch-icon"]').href =
                    '/apple-icon-180x180-local.png'
            }

            // Analytics only in production
            if (import.meta.env.PROD) {
                const s = document.createElement('script')
                s.src = 'https://backoffice-usage.baltic-watches.com/api/script.js'
                s.dataset.siteId = '566ade220ff6'
                s.defer = true
                document.head.appendChild(s)
            }
        